
export default function CasesSection() {
  const cases = [
    {
      title: 'Case 1: Volledige Integratie met PlusOV',
      period: 'Sinds 1 augustus 2019',
      description: 'Complete implementatie van EasyTravel voor alle vervoersprocessen',
      modules: [
        'Data Import & Validatie',
        'Intelligente Planning',
        'Realtime Monitoring',
        'Geautomatiseerde Afrekening',
        'Beleidsdata Verzameling'
      ],
      results: [
        { label: 'Tijdsbesparing', value: '40%' },
        { label: 'Kostenbesparing', value: '25%' },
        { label: 'Klanttevredenheid', value: '95%' }
      ],
      icon: 'ri-building-line',
      color: 'from-blue-500 to-blue-600',
      logo: 'https://static.readdy.ai/image/9bbaefa2db83d27f3b99b300a515e0ca/c9cc070ad9a6abaa993c35d6e40511a7.png'
    },
    {
      title: 'Case 2: Project Den Helder',
      period: 'Sinds 1 januari 2021',
      description: 'Focus op reizigersregistratie, monitoring en financiële transparantie',
      modules: [
        'Reizigersregistratie',
        'Realtime Monitoring',
        'Self-billing Afrekening',
        'Beleidsdata & Rapportage',
        'Kwaliteitsborging'
      ],
      results: [
        { label: 'Transparantie', value: '100%' },
        { label: 'Foutreductie', value: '85%' },
        { label: 'Procesefficiëntie', value: '60%' }
      ],
      icon: 'ri-line-chart-line',
      color: 'from-teal-500 to-teal-600',
      logo: 'https://static.readdy.ai/image/9bbaefa2db83d27f3b99b300a515e0ca/2b2a9a45017fa12f72e9fa138a29618d.png'
    },
    {
      title: 'Case 3: Vraagafhankelijk vervoersproject',
      period: 'Succesvol project vanaf 1-8-2016 tot 1-8-2020',
      description: 'Integraal beheer van groepsvervoer én vraagafhankelijk vervoer (AVAN)',
      modules: [
        'Routevervoer Planning',
        'Vraagafhankelijk Vervoer',
        'Gecombineerde Monitoring',
        'Uniforme Afrekening',
        'Geïntegreerde Rapportage'
      ],
      results: [
        { label: 'Flexibiliteit', value: 'Maximaal' },
        { label: 'Schaalbaarheid', value: 'Onbeperkt' },
        { label: 'Integratie', value: 'Naadloos' }
      ],
      icon: 'ri-roadster-line',
      color: 'from-green-500 to-green-600',
      logo: 'https://static.readdy.ai/image/9bbaefa2db83d27f3b99b300a515e0ca/882e080ad9accd1e07318caa8ed01c74.png'
    }
  ];

  return (
    <section id="cases" className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Bewezen Effectiviteit: Onze Gebruikers
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Praktijkvoorbeelden die de kracht van EasyTravel demonstreren
          </p>
        </div>

        <div className="space-y-6 sm:space-y-8">
          {cases.map((caseItem, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-6 sm:p-8 border border-gray-200"
            >
              <div className="grid lg:grid-cols-3 gap-6 sm:gap-8">
                {/* Case Info */}
                <div className="lg:col-span-2">
                  <div className="flex items-start space-x-4 mb-6">
                    <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br ${caseItem.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                      <i className={`${caseItem.icon} text-2xl sm:text-3xl text-white`}></i>
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2 space-y-2 sm:space-y-0">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
                          {caseItem.title}
                        </h3>
                        {caseItem.logo && (
                          <img 
                            src={caseItem.logo} 
                            alt="Logo" 
                            className="h-6 sm:h-8 w-auto opacity-80 self-start sm:self-center"
                          />
                        )}
                      </div>
                      <div className="inline-block bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-xs sm:text-sm font-semibold">
                        {caseItem.period}
                      </div>
                    </div>
                  </div>

                  <p className="text-gray-700 mb-6 leading-relaxed text-sm sm:text-base">
                    {caseItem.description}
                  </p>

                  <div>
                    <h4 className="font-bold text-gray-900 mb-4 text-sm sm:text-base">Geïmplementeerde Modules</h4>
                    <div className="grid sm:grid-cols-2 gap-3">
                      {caseItem.modules.map((module, mIndex) => (
                        <div key={mIndex} className="flex items-center space-x-2">
                          <div className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                            <i className="ri-check-line text-white text-xs"></i>
                          </div>
                          <span className="text-xs sm:text-sm text-gray-700">{module}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Results */}
                <div className="bg-white rounded-xl shadow-md p-4 sm:p-6 border border-gray-200">
                  <h4 className="font-bold text-gray-900 mb-4 sm:mb-6 text-sm sm:text-base">Resultaten</h4>
                  <div className="space-y-4 sm:space-y-6">
                    {caseItem.results.map((result, rIndex) => (
                      <div key={rIndex}>
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-xs sm:text-sm text-gray-600">{result.label}</span>
                          <span className="text-base sm:text-lg font-bold text-teal-600">{result.value}</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div
                            className="bg-gradient-to-r from-teal-500 to-teal-600 h-2 rounded-full"
                            style={{
                              width: typeof result.value === 'string' && result.value.includes('%')
                                ? result.value
                                : '100%'
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 sm:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 sm:p-6 text-center">
            <div className="text-3xl sm:text-4xl font-bold text-blue-900 mb-2">30+</div>
            <div className="text-blue-700 font-medium text-xs sm:text-sm">Jaar Ervaring</div>
          </div>
          <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-4 sm:p-6 text-center">
            <div className="text-3xl sm:text-4xl font-bold text-teal-900 mb-2">99.8%</div>
            <div className="text-teal-700 font-medium text-xs sm:text-sm">Uptime Garantie</div>
          </div>
          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-4 sm:p-6 text-center">
            <div className="text-3xl sm:text-4xl font-bold text-green-900 mb-2">7/7</div>
            <div className="text-green-700 font-medium text-xs sm:text-sm">Support</div>
          </div>
          <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4 sm:p-6 text-center">
            <div className="text-3xl sm:text-4xl font-bold text-purple-900 mb-2">∞</div>
            <div className="text-purple-700 font-medium text-xs sm:text-sm">Schaalbaarheid</div>
          </div>
        </div>
      </div>
    </section>
  );
}
